import { Model as e } from "../../../../model.js";
class r extends e {
  constructor(o) {
    super(), this.favicon = o.favicon, this.background = o.background;
  }
}
export {
  r as CheckoutDesignImagesModel
};
//# sourceMappingURL=images.model.js.map
